var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BounceOutUp = exports.BounceOutRight = exports.BounceOutLeft = exports.BounceOutDown = exports.BounceOut = exports.BounceInUp = exports.BounceInRight = exports.BounceInLeft = exports.BounceInDown = exports.BounceIn = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _animation = require("../../animation");
var _animationBuilder = require("../animationBuilder");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var _worklet_10440293429573_init_data = {
    code: "function anonymous(){const{delayFunction,delay,withSequence,withTiming,duration,initialValues,callback}=this.__closure;return{animations:{transform:[{scale:delayFunction(delay,withSequence(withTiming(1.2,{duration:duration*0.55}),withTiming(0.9,{duration:duration*0.15}),withTiming(1.1,{duration:duration*0.15}),withTiming(1,{duration:duration*0.15})))}]},initialValues:{transform:[{scale:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","withSequence","withTiming","duration","initialValues","callback","__closure","animations","transform","scale"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts"],"mappings":"AAiCW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,YAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,KAAK,CAAEV,aAAa,CAClBC,KAAK,CACLC,YAAY,CACVC,UAAU,CAAC,GAAG,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,GAAG,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,GAAG,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,CAAC,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAC7C,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,KAAK,CAAE,CAAE,CAAC,CAAC,CACzB,GAAGL,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var BounceIn = exports.BounceIn = function(_ComplexAnimationBuil) {
    (0, _inherits2.default)(BounceIn, _ComplexAnimationBuil);
    var _super = _createSuper(BounceIn);
    function BounceIn() {
        var _this;
        (0, _classCallCheck2.default)(this, BounceIn);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.build = function() {
            var delayFunction = _this.getDelayFunction();
            var delay = _this.getDelay();
            var duration = _this.getDuration();
            var callback = _this.callbackV;
            var initialValues = _this.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            transform: [
                                {
                                    scale: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(1.2, {
                                        duration: duration * 0.55
                                    }), (0, _animation.withTiming)(0.9, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(1.1, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(1, {
                                        duration: duration * 0.15
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    scale: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withSequence: _animation.withSequence,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_10440293429573_init_data;
                anonymous.__workletHash = 10440293429573;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this;
    }
    (0, _createClass2.default)(BounceIn, [
        {
            key: "getDuration",
            value: function getDuration() {
                var _this$durationV;
                return (_this$durationV = this.durationV) != null ? _this$durationV : 600;
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                return new BounceIn();
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 600;
            }
        }
    ]);
    return BounceIn;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_2531551955887_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withSequence,withTiming,duration,initialValues,callback}=this.__closure;return{animations:{transform:[{translateY:delayFunction(delay,withSequence(withTiming(-20,{duration:duration*0.55}),withTiming(10,{duration:duration*0.15}),withTiming(-10,{duration:duration*0.15}),withTiming(0,{duration:duration*0.15})))}]},initialValues:{transform:[{translateY:values.windowHeight}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withSequence","withTiming","duration","initialValues","callback","__closure","animations","transform","translateY","windowHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts"],"mappings":"AAsFW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,YAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,UAAU,CAAEV,aAAa,CACvBC,KAAK,CACLC,YAAY,CACVC,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,CAAC,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAC7C,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CACT,CACEC,UAAU,CAAEX,MAAM,CAACY,YACrB,CAAC,CACF,CACD,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var BounceInDown = exports.BounceInDown = function(_ComplexAnimationBuil2) {
    (0, _inherits2.default)(BounceInDown, _ComplexAnimationBuil2);
    var _super2 = _createSuper(BounceInDown);
    function BounceInDown() {
        var _this2;
        (0, _classCallCheck2.default)(this, BounceInDown);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
            args[_key2] = arguments[_key2];
        }
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.build = function() {
            var delayFunction = _this2.getDelayFunction();
            var delay = _this2.getDelay();
            var duration = _this2.getDuration();
            var callback = _this2.callbackV;
            var initialValues = _this2.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateY: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(-20, {
                                        duration: duration * 0.55
                                    }), (0, _animation.withTiming)(10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(-10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(0, {
                                        duration: duration * 0.15
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateY: values.windowHeight
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withSequence: _animation.withSequence,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_2531551955887_init_data;
                anonymous.__workletHash = 2531551955887;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this2;
    }
    (0, _createClass2.default)(BounceInDown, [
        {
            key: "getDuration",
            value: function getDuration() {
                var _this$durationV2;
                return (_this$durationV2 = this.durationV) != null ? _this$durationV2 : 600;
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                return new BounceInDown();
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 600;
            }
        }
    ]);
    return BounceInDown;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_1558427162287_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withSequence,withTiming,duration,initialValues,callback}=this.__closure;return{animations:{transform:[{translateY:delayFunction(delay,withSequence(withTiming(20,{duration:duration*0.55}),withTiming(-10,{duration:duration*0.15}),withTiming(10,{duration:duration*0.15}),withTiming(0,{duration:duration*0.15})))}]},initialValues:{transform:[{translateY:-values.windowHeight}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withSequence","withTiming","duration","initialValues","callback","__closure","animations","transform","translateY","windowHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts"],"mappings":"AA+IW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,YAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,UAAU,CAAEV,aAAa,CACvBC,KAAK,CACLC,YAAY,CACVC,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAAC,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAC7C,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAACX,MAAM,CAACY,YAAa,CAAC,CAAC,CACjD,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var BounceInUp = exports.BounceInUp = function(_ComplexAnimationBuil3) {
    (0, _inherits2.default)(BounceInUp, _ComplexAnimationBuil3);
    var _super3 = _createSuper(BounceInUp);
    function BounceInUp() {
        var _this3;
        (0, _classCallCheck2.default)(this, BounceInUp);
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++){
            args[_key3] = arguments[_key3];
        }
        _this3 = _super3.call.apply(_super3, [
            this
        ].concat(args));
        _this3.build = function() {
            var delayFunction = _this3.getDelayFunction();
            var delay = _this3.getDelay();
            var duration = _this3.getDuration();
            var callback = _this3.callbackV;
            var initialValues = _this3.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateY: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(20, {
                                        duration: duration * 0.55
                                    }), (0, _animation.withTiming)(-10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(0, {
                                        duration: duration * 0.15
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateY: -values.windowHeight
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withSequence: _animation.withSequence,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_1558427162287_init_data;
                anonymous.__workletHash = 1558427162287;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this3;
    }
    (0, _createClass2.default)(BounceInUp, [
        {
            key: "getDuration",
            value: function getDuration() {
                var _this$durationV3;
                return (_this$durationV3 = this.durationV) != null ? _this$durationV3 : 600;
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                return new BounceInUp();
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 600;
            }
        }
    ]);
    return BounceInUp;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_2042721418742_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withSequence,withTiming,duration,initialValues,callback}=this.__closure;return{animations:{transform:[{translateX:delayFunction(delay,withSequence(withTiming(20,{duration:duration*0.55}),withTiming(-10,{duration:duration*0.15}),withTiming(10,{duration:duration*0.15}),withTiming(0,{duration:duration*0.15})))}]},initialValues:{transform:[{translateX:-values.windowWidth}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withSequence","withTiming","duration","initialValues","callback","__closure","animations","transform","translateX","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts"],"mappings":"AAoMW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,YAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,UAAU,CAAEV,aAAa,CACvBC,KAAK,CACLC,YAAY,CACVC,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAAC,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAC7C,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAACX,MAAM,CAACY,WAAY,CAAC,CAAC,CAChD,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var BounceInLeft = exports.BounceInLeft = function(_ComplexAnimationBuil4) {
    (0, _inherits2.default)(BounceInLeft, _ComplexAnimationBuil4);
    var _super4 = _createSuper(BounceInLeft);
    function BounceInLeft() {
        var _this4;
        (0, _classCallCheck2.default)(this, BounceInLeft);
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
            args[_key4] = arguments[_key4];
        }
        _this4 = _super4.call.apply(_super4, [
            this
        ].concat(args));
        _this4.build = function() {
            var delayFunction = _this4.getDelayFunction();
            var delay = _this4.getDelay();
            var duration = _this4.getDuration();
            var callback = _this4.callbackV;
            var initialValues = _this4.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateX: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(20, {
                                        duration: duration * 0.55
                                    }), (0, _animation.withTiming)(-10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(0, {
                                        duration: duration * 0.15
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateX: -values.windowWidth
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withSequence: _animation.withSequence,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_2042721418742_init_data;
                anonymous.__workletHash = 2042721418742;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this4;
    }
    (0, _createClass2.default)(BounceInLeft, [
        {
            key: "getDuration",
            value: function getDuration() {
                var _this$durationV4;
                return (_this$durationV4 = this.durationV) != null ? _this$durationV4 : 600;
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                return new BounceInLeft();
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 600;
            }
        }
    ]);
    return BounceInLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_13054917124694_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withSequence,withTiming,duration,initialValues,callback}=this.__closure;return{animations:{transform:[{translateX:delayFunction(delay,withSequence(withTiming(-20,{duration:duration*0.55}),withTiming(10,{duration:duration*0.15}),withTiming(-10,{duration:duration*0.15}),withTiming(0,{duration:duration*0.15})))}]},initialValues:{transform:[{translateX:values.windowWidth}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withSequence","withTiming","duration","initialValues","callback","__closure","animations","transform","translateX","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts"],"mappings":"AAyPW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,YAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,UAAU,CAAEV,aAAa,CACvBC,KAAK,CACLC,YAAY,CACVC,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,CAAC,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAC7C,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAEX,MAAM,CAACY,WAAY,CAAC,CAAC,CAC/C,GAAGN,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var BounceInRight = exports.BounceInRight = function(_ComplexAnimationBuil5) {
    (0, _inherits2.default)(BounceInRight, _ComplexAnimationBuil5);
    var _super5 = _createSuper(BounceInRight);
    function BounceInRight() {
        var _this5;
        (0, _classCallCheck2.default)(this, BounceInRight);
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++){
            args[_key5] = arguments[_key5];
        }
        _this5 = _super5.call.apply(_super5, [
            this
        ].concat(args));
        _this5.build = function() {
            var delayFunction = _this5.getDelayFunction();
            var delay = _this5.getDelay();
            var duration = _this5.getDuration();
            var callback = _this5.callbackV;
            var initialValues = _this5.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateX: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(-20, {
                                        duration: duration * 0.55
                                    }), (0, _animation.withTiming)(10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(-10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(0, {
                                        duration: duration * 0.15
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateX: values.windowWidth
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withSequence: _animation.withSequence,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_13054917124694_init_data;
                anonymous.__workletHash = 13054917124694;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this5;
    }
    (0, _createClass2.default)(BounceInRight, [
        {
            key: "getDuration",
            value: function getDuration() {
                var _this$durationV5;
                return (_this$durationV5 = this.durationV) != null ? _this$durationV5 : 600;
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                return new BounceInRight();
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 600;
            }
        }
    ]);
    return BounceInRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_10359139755781_init_data = {
    code: "function anonymous(){const{delayFunction,delay,withSequence,withTiming,duration,initialValues,callback}=this.__closure;return{animations:{transform:[{scale:delayFunction(delay,withSequence(withTiming(1.1,{duration:duration*0.15}),withTiming(0.9,{duration:duration*0.15}),withTiming(1.2,{duration:duration*0.15}),withTiming(0,{duration:duration*0.55})))}]},initialValues:{transform:[{scale:1}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts",
    sourceMap: '{"version":3,"names":["anonymous","delayFunction","delay","withSequence","withTiming","duration","initialValues","callback","__closure","animations","transform","scale"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts"],"mappings":"AA8SW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,YAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,KAAK,CAAEV,aAAa,CAClBC,KAAK,CACLC,YAAY,CACVC,UAAU,CAAC,GAAG,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,GAAG,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,GAAG,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,CAAC,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAC7C,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,KAAK,CAAE,CAAE,CAAC,CAAC,CACzB,GAAGL,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var BounceOut = exports.BounceOut = function(_ComplexAnimationBuil6) {
    (0, _inherits2.default)(BounceOut, _ComplexAnimationBuil6);
    var _super6 = _createSuper(BounceOut);
    function BounceOut() {
        var _this6;
        (0, _classCallCheck2.default)(this, BounceOut);
        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++){
            args[_key6] = arguments[_key6];
        }
        _this6 = _super6.call.apply(_super6, [
            this
        ].concat(args));
        _this6.build = function() {
            var delayFunction = _this6.getDelayFunction();
            var delay = _this6.getDelay();
            var duration = _this6.getDuration();
            var callback = _this6.callbackV;
            var initialValues = _this6.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        animations: {
                            transform: [
                                {
                                    scale: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(1.1, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(0.9, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(1.2, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(0, {
                                        duration: duration * 0.55
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    scale: 1
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withSequence: _animation.withSequence,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_10359139755781_init_data;
                anonymous.__workletHash = 10359139755781;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this6;
    }
    (0, _createClass2.default)(BounceOut, [
        {
            key: "getDuration",
            value: function getDuration() {
                var _this$durationV6;
                return (_this$durationV6 = this.durationV) != null ? _this$durationV6 : 600;
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                return new BounceOut();
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 600;
            }
        }
    ]);
    return BounceOut;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_9784251689903_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withSequence,withTiming,duration,initialValues,callback}=this.__closure;return{animations:{transform:[{translateY:delayFunction(delay,withSequence(withTiming(-10,{duration:duration*0.15}),withTiming(10,{duration:duration*0.15}),withTiming(-20,{duration:duration*0.15}),withTiming(values.windowHeight,{duration:duration*0.55})))}]},initialValues:{transform:[{translateY:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withSequence","withTiming","duration","initialValues","callback","__closure","animations","transform","translateY","windowHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts"],"mappings":"AAmWW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,YAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,UAAU,CAAEV,aAAa,CACvBC,KAAK,CACLC,YAAY,CACVC,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAACJ,MAAM,CAACY,YAAY,CAAE,CAC9BP,QAAQ,CAAEA,QAAQ,CAAG,IACvB,CAAC,CACH,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAC,CAC9B,GAAGL,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var BounceOutDown = exports.BounceOutDown = function(_ComplexAnimationBuil7) {
    (0, _inherits2.default)(BounceOutDown, _ComplexAnimationBuil7);
    var _super7 = _createSuper(BounceOutDown);
    function BounceOutDown() {
        var _this7;
        (0, _classCallCheck2.default)(this, BounceOutDown);
        for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++){
            args[_key7] = arguments[_key7];
        }
        _this7 = _super7.call.apply(_super7, [
            this
        ].concat(args));
        _this7.build = function() {
            var delayFunction = _this7.getDelayFunction();
            var delay = _this7.getDelay();
            var duration = _this7.getDuration();
            var callback = _this7.callbackV;
            var initialValues = _this7.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateY: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(-10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(-20, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(values.windowHeight, {
                                        duration: duration * 0.55
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateY: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withSequence: _animation.withSequence,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_9784251689903_init_data;
                anonymous.__workletHash = 9784251689903;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this7;
    }
    (0, _createClass2.default)(BounceOutDown, [
        {
            key: "getDuration",
            value: function getDuration() {
                var _this$durationV7;
                return (_this$durationV7 = this.durationV) != null ? _this$durationV7 : 600;
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                return new BounceOutDown();
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 600;
            }
        }
    ]);
    return BounceOutDown;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_4673100596943_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withSequence,withTiming,duration,initialValues,callback}=this.__closure;return{animations:{transform:[{translateY:delayFunction(delay,withSequence(withTiming(10,{duration:duration*0.15}),withTiming(-10,{duration:duration*0.15}),withTiming(20,{duration:duration*0.15}),withTiming(-values.windowHeight,{duration:duration*0.55})))}]},initialValues:{transform:[{translateY:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withSequence","withTiming","duration","initialValues","callback","__closure","animations","transform","translateY","windowHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts"],"mappings":"AA0ZW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,YAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,UAAU,CAAEV,aAAa,CACvBC,KAAK,CACLC,YAAY,CACVC,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAACJ,MAAM,CAACY,YAAY,CAAE,CAC/BP,QAAQ,CAAEA,QAAQ,CAAG,IACvB,CAAC,CACH,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAC,CAC9B,GAAGL,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var BounceOutUp = exports.BounceOutUp = function(_ComplexAnimationBuil8) {
    (0, _inherits2.default)(BounceOutUp, _ComplexAnimationBuil8);
    var _super8 = _createSuper(BounceOutUp);
    function BounceOutUp() {
        var _this8;
        (0, _classCallCheck2.default)(this, BounceOutUp);
        for(var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++){
            args[_key8] = arguments[_key8];
        }
        _this8 = _super8.call.apply(_super8, [
            this
        ].concat(args));
        _this8.build = function() {
            var delayFunction = _this8.getDelayFunction();
            var delay = _this8.getDelay();
            var duration = _this8.getDuration();
            var callback = _this8.callbackV;
            var initialValues = _this8.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateY: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(-10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(20, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(-values.windowHeight, {
                                        duration: duration * 0.55
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateY: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withSequence: _animation.withSequence,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_4673100596943_init_data;
                anonymous.__workletHash = 4673100596943;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this8;
    }
    (0, _createClass2.default)(BounceOutUp, [
        {
            key: "getDuration",
            value: function getDuration() {
                var _this$durationV8;
                return (_this$durationV8 = this.durationV) != null ? _this$durationV8 : 600;
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                return new BounceOutUp();
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 600;
            }
        }
    ]);
    return BounceOutUp;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_3105486463862_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withSequence,withTiming,duration,initialValues,callback}=this.__closure;return{animations:{transform:[{translateX:delayFunction(delay,withSequence(withTiming(10,{duration:duration*0.15}),withTiming(-10,{duration:duration*0.15}),withTiming(20,{duration:duration*0.15}),withTiming(-values.windowWidth,{duration:duration*0.55})))}]},initialValues:{transform:[{translateX:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withSequence","withTiming","duration","initialValues","callback","__closure","animations","transform","translateX","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts"],"mappings":"AAidW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,YAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,UAAU,CAAEV,aAAa,CACvBC,KAAK,CACLC,YAAY,CACVC,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAACJ,MAAM,CAACY,WAAW,CAAE,CAC9BP,QAAQ,CAAEA,QAAQ,CAAG,IACvB,CAAC,CACH,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAC,CAC9B,GAAGL,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var BounceOutLeft = exports.BounceOutLeft = function(_ComplexAnimationBuil9) {
    (0, _inherits2.default)(BounceOutLeft, _ComplexAnimationBuil9);
    var _super9 = _createSuper(BounceOutLeft);
    function BounceOutLeft() {
        var _this9;
        (0, _classCallCheck2.default)(this, BounceOutLeft);
        for(var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++){
            args[_key9] = arguments[_key9];
        }
        _this9 = _super9.call.apply(_super9, [
            this
        ].concat(args));
        _this9.build = function() {
            var delayFunction = _this9.getDelayFunction();
            var delay = _this9.getDelay();
            var duration = _this9.getDuration();
            var callback = _this9.callbackV;
            var initialValues = _this9.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateX: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(-10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(20, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(-values.windowWidth, {
                                        duration: duration * 0.55
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateX: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withSequence: _animation.withSequence,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_3105486463862_init_data;
                anonymous.__workletHash = 3105486463862;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this9;
    }
    (0, _createClass2.default)(BounceOutLeft, [
        {
            key: "getDuration",
            value: function getDuration() {
                var _this$durationV9;
                return (_this$durationV9 = this.durationV) != null ? _this$durationV9 : 600;
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                return new BounceOutLeft();
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 600;
            }
        }
    ]);
    return BounceOutLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_5151277885014_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withSequence,withTiming,duration,initialValues,callback}=this.__closure;return{animations:{transform:[{translateX:delayFunction(delay,withSequence(withTiming(-10,{duration:duration*0.15}),withTiming(10,{duration:duration*0.15}),withTiming(-20,{duration:duration*0.15}),withTiming(values.windowWidth,{duration:duration*0.55})))}]},initialValues:{transform:[{translateX:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withSequence","withTiming","duration","initialValues","callback","__closure","animations","transform","translateX","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Bounce.ts"],"mappings":"AAwgBW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,YAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,SAAS,CAAE,CACT,CACEC,UAAU,CAAEV,aAAa,CACvBC,KAAK,CACLC,YAAY,CACVC,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC7CD,UAAU,CAAC,CAAC,EAAE,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAC9CD,UAAU,CAACJ,MAAM,CAACY,WAAW,CAAE,CAC7BP,QAAQ,CAAEA,QAAQ,CAAG,IACvB,CAAC,CACH,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAC,CAC9B,GAAGL,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var BounceOutRight = exports.BounceOutRight = function(_ComplexAnimationBuil10) {
    (0, _inherits2.default)(BounceOutRight, _ComplexAnimationBuil10);
    var _super10 = _createSuper(BounceOutRight);
    function BounceOutRight() {
        var _this10;
        (0, _classCallCheck2.default)(this, BounceOutRight);
        for(var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++){
            args[_key10] = arguments[_key10];
        }
        _this10 = _super10.call.apply(_super10, [
            this
        ].concat(args));
        _this10.build = function() {
            var delayFunction = _this10.getDelayFunction();
            var delay = _this10.getDelay();
            var duration = _this10.getDuration();
            var callback = _this10.callbackV;
            var initialValues = _this10.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            transform: [
                                {
                                    translateX: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(-10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(10, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(-20, {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)(values.windowWidth, {
                                        duration: duration * 0.55
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            transform: [
                                {
                                    translateX: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withSequence: _animation.withSequence,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_5151277885014_init_data;
                anonymous.__workletHash = 5151277885014;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this10;
    }
    (0, _createClass2.default)(BounceOutRight, [
        {
            key: "getDuration",
            value: function getDuration() {
                var _this$durationV10;
                return (_this$durationV10 = this.durationV) != null ? _this$durationV10 : 600;
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                return new BounceOutRight();
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 600;
            }
        }
    ]);
    return BounceOutRight;
}(_animationBuilder.ComplexAnimationBuilder);
